import * as actionCreatorFactory from "typescript-fsa";

import { HttpStateError } from "@orm/models";
import * as actionTypes from "../constants";

const actionCreator = actionCreatorFactory.default();

// Route
export const requestRoute = actionCreator<{}>(actionTypes.ROUTE_REQUEST);
export const routeSuccess = actionCreator<string>(actionTypes.ROUTE_SUCCESS);
export const routeFailure = actionCreator<HttpStateError>(actionTypes.ROUTE_FAILURE);

// Login
export const login = actionCreator<{}>(actionTypes.LOGIN);
